// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/emitten/entity/v2/company_detail.proto (package financial.emitten.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { ExtraAttributes } from "../v1/extra_pb.js";
import { PaginateDetails } from "./paginate_pb.js";

/**
 * @generated from enum financial.emitten.entity.v2.FRStatus
 */
export const FRStatus = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v2.FRStatus",
  [
    {no: 0, name: "FR_STATUS_UNSPECIFIED"},
    {no: 1, name: "FR_STATUS_ACTIVE"},
    {no: 2, name: "FR_STATUS_MATURED"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.SortOrder
 */
export const SortOrder = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v2.SortOrder",
  [
    {no: 0, name: "SORT_ORDER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SORT_ORDER_ASC", localName: "ASC"},
    {no: 2, name: "SORT_ORDER_DESC", localName: "DESC"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.Status
 */
export const Status = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v2.Status",
  [
    {no: 0, name: "STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 1, name: "STATUS_SUSPENDED", localName: "SUSPENDED"},
    {no: 2, name: "STATUS_DELISTED", localName: "DELISTED"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.StatusV2
 */
export const StatusV2 = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v2.StatusV2",
  [
    {no: 0, name: "STATUS_V2_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_V2_ACTIVE", localName: "ACTIVE"},
    {no: 2, name: "STATUS_V2_SUSPENDED", localName: "SUSPENDED"},
    {no: 3, name: "STATUS_V2_DELISTED", localName: "DELISTED"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.CompanyType
 */
export const CompanyType = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v2.CompanyType",
  [
    {no: 0, name: "COMPANY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMPANY_TYPE_SAHAM", localName: "SAHAM"},
    {no: 2, name: "COMPANY_TYPE_INDEX", localName: "INDEX"},
    {no: 3, name: "COMPANY_TYPE_FX", localName: "FX"},
    {no: 4, name: "COMPANY_TYPE_ETF", localName: "ETF"},
    {no: 5, name: "COMPANY_TYPE_INDEX_ASING", localName: "INDEX_ASING"},
    {no: 6, name: "COMPANY_TYPE_COMMODITIES", localName: "COMMODITIES"},
    {no: 7, name: "COMPANY_TYPE_CRYPTO", localName: "CRYPTO"},
    {no: 8, name: "COMPANY_TYPE_WARAN", localName: "WARAN"},
    {no: 9, name: "COMPANY_TYPE_RIGHT", localName: "RIGHT"},
    {no: 10, name: "COMPANY_TYPE_REKSADANA", localName: "REKSADANA"},
    {no: 11, name: "COMPANY_TYPE_OBLIGASI", localName: "OBLIGASI"},
    {no: 12, name: "COMPANY_TYPE_DIRE", localName: "DIRE"},
    {no: 13, name: "COMPANY_TYPE_FR", localName: "FR"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.Exchange
 */
export const Exchange = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v2.Exchange",
  [
    {no: 0, name: "EXCHANGE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EXCHANGE_IDX", localName: "IDX"},
    {no: 2, name: "EXCHANGE_KLSE", localName: "KLSE"},
    {no: 3, name: "EXCHANGE_SGX", localName: "SGX"},
  ],
);

/**
 * @generated from enum financial.emitten.entity.v2.StockType
 */
export const StockType = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v2.StockType",
  [
    {no: 0, name: "STOCK_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STOCK_TYPE_COMMON", localName: "COMMON"},
    {no: 2, name: "STOCK_TYPE_PREFERRED", localName: "PREFERRED"},
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.EmittenInfoData
 */
export const EmittenInfoData = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenInfoData",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "catalogs", kind: "message", T: Catalog, repeated: true },
    { no: 7, name: "tags", kind: "message", T: EmittenTag, repeated: true },
    { no: 8, name: "tradable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "company_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "metadata", kind: "message", T: EmittenMetadata, repeated: true },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.EmittenMetadata
 */
export const EmittenMetadata = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenMetadata",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.EmittenTag
 */
export const EmittenTag = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenTag",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Stock
 */
export const Stock = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.Stock",
  () => [
    { no: 1, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "last", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "company_id", jsonName: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "notation", kind: "message", T: Notation, repeated: true },
    { no: 10, name: "uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "corp_action", jsonName: "corp_action", kind: "message", T: CorpAction },
    { no: 15, name: "isexist", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 17, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "is_following", jsonName: "is_following", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "formatted_price", jsonName: "formatted_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.CorpAction
 */
export const CorpAction = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.CorpAction",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Notation
 */
export const Notation = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.Notation",
  () => [
    { no: 1, name: "notation_code", jsonName: "notation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "notation_desc", jsonName: "notation_desc", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon_url", jsonName: "icon_url", kind: "message", T: IconURL },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.IconURL
 */
export const IconURL = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.IconURL",
  () => [
    { no: 1, name: "light_mode", jsonName: "light_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dark_mode", jsonName: "dark_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.DayTradeInfo
 */
export const DayTradeInfo = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.DayTradeInfo",
  () => [
    { no: 1, name: "is_show_multiplier", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "multiplier", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.CompanyPageInfo
 */
export const CompanyPageInfo = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyPageInfo",
  () => [
    { no: 1, name: "aum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "average", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "followed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "followers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "indexes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "orderbook", kind: "message", T: OrderTrade },
    { no: 14, name: "percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "prices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "sector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "sentiment", kind: "message", T: Sentiments },
    { no: 20, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 21, name: "sub_sector", jsonName: "sub_sector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "tabs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 26, name: "time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "type_company", jsonName: "type_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "volume", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 32, name: "market_hour", jsonName: "market_hour", kind: "message", T: MarketHour },
    { no: 33, name: "is_holding_exist", jsonName: "is_holding_exist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 34, name: "formatted_price", jsonName: "formatted_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "is_price_alert_exist", jsonName: "is_price_alert_exist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 36, name: "notation", kind: "message", T: Notation, repeated: true },
    { no: 37, name: "trade_type", jsonName: "trade_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "catalogs", kind: "message", T: Catalog, repeated: true },
    { no: 39, name: "indexes_data", jsonName: "indexes_data", kind: "message", T: IndexesInfo, repeated: true },
    { no: 40, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "corp_action", jsonName: "corp_action", kind: "message", T: CorpAction },
    { no: 42, name: "uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 43, name: "day_trade_multiplier", jsonName: "day_trade_multiplier", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 44, name: "day_trade_info", jsonName: "day_trade_info", kind: "message", T: DayTradeInfo },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Catalog
 */
export const Catalog = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.Catalog",
  () => [
    { no: 1, name: "company_symbol", jsonName: "company_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "catalog_name", jsonName: "catalog_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "company_type", jsonName: "company_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "show", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.IndexesInfo
 */
export const IndexesInfo = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.IndexesInfo",
  () => [
    { no: 1, name: "company_symbol", jsonName: "company_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company_type", jsonName: "company_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.MarketHour
 */
export const MarketHour = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.MarketHour",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "time_left", jsonName: "time_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "formatted_time_left", jsonName: "formatted_time_left", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "suspend_info", jsonName: "suspend_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.OrderPriceVol
 */
export const OrderPriceVol = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.OrderPriceVol",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "volume", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.OrderTrade
 */
export const OrderTrade = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.OrderTrade",
  () => [
    { no: 1, name: "bid", kind: "message", T: OrderPriceVol },
    { no: 2, name: "offer", kind: "message", T: OrderPriceVol },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Sentiments
 */
export const Sentiments = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.Sentiments",
  () => [
    { no: 1, name: "end_value", jsonName: "end_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_value", jsonName: "start_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.SectorCatalog
 */
export const SectorCatalog = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.SectorCatalog",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "total_stock", jsonName: "total_stock", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.PopularStock
 */
export const PopularStock = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.PopularStock",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_following", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Company
 */
export const Company = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.Company",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.SectorSubsectorCompany
 */
export const SectorSubsectorCompany = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.SectorSubsectorCompany",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "alias1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.CompanyInIndustry
 */
export const CompanyInIndustry = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyInIndustry",
  () => [
    { no: 1, name: "avgvolume", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "company_id", jsonName: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "followed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "followers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "isexist", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "last", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "marketcap", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "popularity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "type_company", jsonName: "type_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "valuema20", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "volume", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "formatted_price", jsonName: "formatted_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.ListDiscover
 */
export const ListDiscover = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.ListDiscover",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "last", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "percent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "isexist", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "notation", kind: "message", T: Notation, repeated: true },
    { no: 11, name: "uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "corp_action", jsonName: "corp_action", kind: "message", T: CorpAction },
    { no: 13, name: "is_exists", jsonName: "is_exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "extra_attributes", jsonName: "extra_attributes", kind: "message", T: ExtraAttributes },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.ListFinancialDiscover
 */
export const ListFinancialDiscover = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.ListFinancialDiscover",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "companies", kind: "message", T: ListDiscover, repeated: true },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.CompanyDetail
 */
export const CompanyDetail = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyDetail",
  () => [
    { no: 1, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol_3", jsonName: "symbol_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.CompanyContact
 */
export const CompanyContact = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.CompanyContact",
  () => [
    { no: 1, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_followed", jsonName: "is_followed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "thumb", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.GetCompanyDataCatalog
 */
export const GetCompanyDataCatalog = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.GetCompanyDataCatalog",
  () => [
    { no: 1, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "previous", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "last", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "symbol_2", jsonName: "symbol_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.GetCompanyCatalog
 */
export const GetCompanyCatalog = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.GetCompanyCatalog",
  () => [
    { no: 1, name: "pchange_info", jsonName: "pchange_info", kind: "message", T: GetCompanyDataCatalog, repeated: true },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.EmittenList
 */
export const EmittenList = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenList",
  () => [
    { no: 1, name: "emitten_results", jsonName: "emitten_results", kind: "message", T: EmittenResult, repeated: true },
    { no: 2, name: "paginate", kind: "message", T: PaginateDetails },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.EmittenResult
 */
export const EmittenResult = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.EmittenResult",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subsector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status_text", jsonName: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "share_outstanding", jsonName: "share_outstanding", kind: "message", T: ShareOutstanding },
    { no: 11, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "indexes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "listing_boards", jsonName: "listing_boards", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.ShareOutstanding
 */
export const ShareOutstanding = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.ShareOutstanding",
  () => [
    { no: 1, name: "raw", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "formatted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.DetailCompany
 */
export const DetailCompany = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.DetailCompany",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "symbol", kind: "message", T: Symbol },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(CompanyType) },
    { no: 4, name: "sector", kind: "message", T: Sector },
    { no: 5, name: "sub_sector", jsonName: "sub_sector", kind: "message", T: Sector },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(StatusV2) },
    { no: 10, name: "share_outstanding", jsonName: "share_outstanding", kind: "message", T: ShareOutstanding },
    { no: 11, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Sector
 */
export const Sector = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.Sector",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.Symbol
 */
export const Symbol = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.Symbol",
  () => [
    { no: 1, name: "quote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticker", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.SectorCompanyResult
 */
export const SectorCompanyResult = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.SectorCompanyResult",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "alias1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.TypeCompanyResult
 */
export const TypeCompanyResult = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.TypeCompanyResult",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.StatusCompanyResult
 */
export const StatusCompanyResult = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.StatusCompanyResult",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v2.ListComponentCompany
 */
export const ListComponentCompany = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v2.ListComponentCompany",
  () => [
    { no: 1, name: "sectors", kind: "message", T: SectorCompanyResult, repeated: true },
    { no: 2, name: "types", kind: "enum", T: proto3.getEnumType(CompanyType), repeated: true },
    { no: 3, name: "countries", kind: "message", T: TypeCompanyResult, repeated: true },
    { no: 4, name: "statuses", kind: "enum", T: proto3.getEnumType(StatusV2), repeated: true },
  ],
);

